module.exports = __webpack_public_path__ + "img/gain-item5.01d084cf.png";